import { Base } from 'layouts'
import { IndustryForm } from 'components'

import * as S from './styled'

export function IndustryEdit() {
  return (
    <Base>
      <S.GridContainer container>
        <IndustryForm />
      </S.GridContainer>
    </Base>
  )
}
